export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';
export const TOGGLE_ATTENDEES_CHAT = 'TOGGLE_ATTENDEES_CHAT';
